import React from 'react';
import styled from 'styled-components';

const AboutContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 2rem 10rem;
    max-width: 1200px;
    margin: 0 auto;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        flex-direction: column;
        padding: 1rem 0;
    }
`;

const ImageContainer = styled.div`
    flex: 1;
    max-width: 50%;

    @media (max-width: ${props => props.theme.breakpoints.mobile}) {
        padding-top: 30px;
        max-width: 100%;
        margin-bottom: 1rem;
    }
`;

const TextContainer = styled.div`
    flex: 1;
    max-width: 50%;
    font-size: 1rem;
    line-height: 1.6;
    padding-left: 2rem;

    @media (max-width: 768px) {
        max-width: 100%;
        padding-left: 0;
        font-size: 1rem;
    }
`;

const Image = styled.img`
    width: 100%;
    height: auto;
    border-radius: 8px;
`;

const About: React.FC = () => {
    return (
        <AboutContainer>
            <ImageContainer>
                <Image src={`${process.env.PUBLIC_URL}/about/about.jpg`} alt="Flower Image"/>
            </ImageContainer>

            <TextContainer>
                <p>
                    우연히 만난 꽃이 무채색이던
                </p>
                <p>제 삶을 다채로운 색으로 물들였습니다.
                </p>
                <p>
                    그 꽃은 저에게 위로와 기쁨이 되었고,
                </p>
                <p>이제는 그 꽃을 직업으로 삼아
                </p>
                <p>
                    꽃과 함께 산책하듯 걸어가고 있습니다.
                </p>
                <br/>
                <p>
                    사계절의 변화 속에서 꽃의 아름다움을 살리며,
                </p>
                <p>마치 꽃줄기가 바람에 흔들리듯 자연스럽게 연출하며,
                </p>
                <p>
                    매 순간 작은 정원을 그리듯 만들어갑니다.
                </p>
                <br/>
                <p>
                    저는 무용한 아름다움이
                </p>
                <p>우리의 삶에 운율을 더해줄 것이라 믿으며,
                </p>
                <p>
                    오늘도 꽃과 함께 새로운 이야기를 써내려가고 있습니다.
                </p>
            </TextContainer>
        </AboutContainer>
    );
};

export default About;
